var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuAiActLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1188_4192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "#003399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 7.29999L24.2217 9.67763L25.4194 10.0639L25 7.29999Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 7.29999L25.7783 9.67763L24.5806 10.0639L25 7.29999Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3931 9.0318L24.8768 9.02744L24.879 10.2731L27.3931 9.0318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3953 9.02963L25.3597 10.4969L24.6176 9.48341L27.3953 9.02963Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4805 11.8238L25.7005 9.44489L24.5046 9.82994L26.4805 11.8238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4817 11.8225L24.4429 10.3517L25.1819 9.34181L26.4817 11.8225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6072 9.0318L25.1235 9.02744L25.1213 10.2731L22.6072 9.0318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.605 9.02963L24.6405 10.4969L25.3827 9.48341L22.605 9.02963Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5198 11.8238L24.2998 9.44489L25.4957 9.82994L23.5198 11.8238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5186 11.8225L25.5573 10.3517L24.8184 9.34181L23.5186 11.8225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 37.3L24.2217 39.6776L25.4194 40.0639L25 37.3Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 37.3L25.7783 39.6776L24.5806 40.0639L25 37.3Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3931 39.0318L24.8768 39.0274L24.879 40.2731L27.3931 39.0318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3953 39.0296L25.3597 40.4969L24.6176 39.4834L27.3953 39.0296Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4805 41.8238L25.7005 39.4449L24.5046 39.8299L26.4805 41.8238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4817 41.8225L24.4429 40.3517L25.1819 39.3418L26.4817 41.8225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6072 39.0318L25.1235 39.0274L25.1213 40.2731L22.6072 39.0318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.605 39.0296L24.6405 40.4969L25.3827 39.4834L22.605 39.0296Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5198 41.8238L24.2998 39.4449L25.4957 39.8299L23.5198 41.8238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5186 41.8225L25.5573 40.3517L24.8184 39.3418L23.5186 41.8225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88892 22.3L9.11065 24.6776L10.3083 25.0639L9.88892 22.3Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88892 22.3L10.6672 24.6776L9.46955 25.0639L9.88892 22.3Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.282 24.0318L9.76568 24.0274L9.76789 25.2731L12.282 24.0318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2842 24.0296L10.2487 25.4969L9.50648 24.4834L12.2842 24.0296Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3694 26.8238L10.5894 24.4449L9.39349 24.8299L11.3694 26.8238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3706 26.8225L9.33184 25.3517L10.0708 24.3418L11.3706 26.8225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49609 24.0318L10.0124 24.0274L10.0102 25.2731L7.49609 24.0318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4939 24.0296L9.52941 25.4969L10.2716 24.4834L7.4939 24.0296Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40869 26.8238L9.1887 24.4449L10.3846 24.8299L8.40869 26.8238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40747 26.8225L10.4462 25.3517L9.7073 24.3418L8.40747 26.8225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9629 13.8321L18.0017 12.3612L17.2628 11.3514L15.9629 13.8321Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9644 13.8334L16.7444 11.4545L17.9402 11.8395L15.9644 13.8334Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0491 11.0382L17.0855 12.5065L17.8268 11.494L15.0491 11.0382Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0503 11.0394L17.5676 11.037L17.5664 12.2847L15.0503 11.0394Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4463 9.3096L16.6662 11.6885L17.862 12.0735L17.4463 9.3096Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4463 9.3096L18.2227 11.686L17.0233 12.0735L17.4463 9.3096Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9236 13.8321L16.8872 12.364L17.6286 11.3514L18.9236 13.8321Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9246 13.831L18.1479 11.4545L16.9487 11.8419L18.9246 13.831Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8398 11.0361L17.8014 12.5065L17.0621 11.4962L19.8398 11.0361Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8398 11.037L17.3223 11.0389L17.3213 12.287L19.8398 11.037Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3938 19.3238L12.6137 16.9449L11.4179 17.3299L13.3938 19.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.395 19.3225L11.3562 17.8516L12.0951 16.8418L13.395 19.3225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4343 19.3225L12.4707 17.8543L11.7293 16.8418L10.4343 19.3225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4333 19.3214L11.21 16.9449L12.4092 17.3323L10.4333 19.3214Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51807 16.5265L11.5565 17.9969L12.2958 16.9866L9.51807 16.5265Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51807 16.5274L12.0356 16.5293L12.0366 17.7774L9.51807 16.5274Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3088 16.5286L12.2724 17.9969L11.5311 16.9844L14.3088 16.5286Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3076 16.5298L11.7903 16.5274L11.7915 17.775L14.3076 16.5298Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9116 14.8L12.6917 17.1789L11.4959 17.5639L11.9116 14.8Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9116 14.8L11.1352 17.1763L12.3346 17.5639L11.9116 14.8Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3057 31.5336L11.7903 31.5275L11.7934 32.7713L14.3057 31.5336Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3086 31.5306L12.2739 32.9969L11.5309 31.9825L14.3086 31.5306Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3938 34.3258L12.6109 31.9449L11.4179 32.3279L13.3938 34.3258Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3972 34.3225L11.3564 32.8494L12.0932 31.8418L13.3972 34.3225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4353 34.3225L12.4708 32.8553L11.7285 31.8418L10.4353 34.3225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4331 34.3205L11.2085 31.9449L12.409 32.3332L10.4331 34.3205Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9094 29.8L12.6917 32.1804L11.498 32.5639L11.9094 29.8Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9094 29.8L11.1352 32.1749L12.3368 32.5639L11.9094 29.8Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51807 31.5274L12.0353 31.5298L12.0366 32.7774L9.51807 31.5274Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51807 31.5262L11.5567 32.9969L12.2958 31.9868L9.51807 31.5262Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8367 37.024L17.3213 37.0179L17.3244 38.2617L19.8367 37.024Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8396 37.021L17.8049 38.4873L17.0619 37.4729L19.8396 37.021Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9248 39.8162L18.1419 37.4353L16.9489 37.8183L18.9248 39.8162Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9282 39.8129L16.8874 38.3398L17.6242 37.3322L18.9282 39.8129Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9663 39.8129L18.0018 38.3457L17.2595 37.3322L15.9663 39.8129Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9641 39.8109L16.7395 37.4353L17.94 37.8236L15.9641 39.8109Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4404 35.2904L18.2227 37.6708L17.029 38.0543L17.4404 35.2904Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4404 35.2904L16.6662 37.6652L17.8678 38.0543L17.4404 35.2904Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0491 37.0178L17.5663 37.0202L17.5676 38.2678L15.0491 37.0178Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0491 37.0166L17.0877 38.4873L17.8268 37.4772L15.0491 37.0166Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1113 22.3L40.8896 24.6776L39.692 25.0639L40.1113 22.3Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1113 22.3L39.3331 24.6776L40.5307 25.0639L40.1113 22.3Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7183 24.0318L40.2346 24.0274L40.2324 25.2731L37.7183 24.0318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7161 24.0296L39.7516 25.4969L40.4938 24.4834L37.7161 24.0296Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6309 26.8238L39.4109 24.4449L40.6068 24.8299L38.6309 26.8238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6296 26.8225L40.6684 25.3517L39.9295 24.3418L38.6296 26.8225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5042 24.0318L39.9878 24.0274L39.9901 25.2731L42.5042 24.0318Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5063 24.0296L40.4708 25.4969L39.7286 24.4834L42.5063 24.0296Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5916 26.8238L40.8115 24.4449L39.6157 24.8299L41.5916 26.8238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5928 26.8225L39.554 25.3517L40.2929 24.3418L41.5928 26.8225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0374 13.8321L31.9985 12.3612L32.7374 11.3514L34.0374 13.8321Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0359 13.8334L33.2558 11.4545L32.06 11.8395L34.0359 13.8334Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9512 11.0382L32.9147 12.5065L32.1735 11.494L34.9512 11.0382Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.95 11.0394L32.4326 11.037L32.4338 12.2847L34.95 11.0394Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.554 9.3096L33.334 11.6885L32.1382 12.0735L32.554 9.3096Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.554 9.3096L31.7775 11.686L32.977 12.0735L32.554 9.3096Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0767 13.8321L33.113 12.364L32.3717 11.3514L31.0767 13.8321Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0757 13.831L31.8523 11.4545L33.0516 11.8419L31.0757 13.831Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1604 11.0361L32.1988 12.5065L32.9381 11.4962L30.1604 11.0361Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1604 11.037L32.6779 11.0389L32.6789 12.287L30.1604 11.037Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6064 19.3238L37.3865 16.9449L38.5823 17.3299L36.6064 19.3238Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6052 19.3225L38.644 17.8516L37.9052 16.8418L36.6052 19.3225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5659 19.3225L37.5296 17.8543L38.2709 16.8418L39.5659 19.3225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5669 19.3214L38.7903 16.9449L37.591 17.3323L39.5669 19.3214Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4822 16.5265L38.4438 17.9969L37.7045 16.9866L40.4822 16.5265Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4822 16.5274L37.9646 16.5293L37.9637 17.7774L40.4822 16.5274Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6914 16.5286L37.7278 17.9969L38.4691 16.9844L35.6914 16.5286Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6926 16.5298L38.2099 16.5274L38.2088 17.775L35.6926 16.5298Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0886 14.8L37.3085 17.1789L38.5043 17.5639L38.0886 14.8Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0886 14.8L38.8651 17.1763L37.6656 17.5639L38.0886 14.8Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6946 31.5336L38.21 31.5275L38.2069 32.7713L35.6946 31.5336Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6917 31.5306L37.7263 32.9969L38.4693 31.9825L35.6917 31.5306Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6064 34.3258L37.3894 31.9449L38.5823 32.3279L36.6064 34.3258Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.603 34.3225L38.6439 32.8494L37.907 31.8418L36.603 34.3225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5649 34.3225L37.5295 32.8553L38.2717 31.8418L39.5649 34.3225Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5671 34.3205L38.7918 31.9449L37.5912 32.3332L39.5671 34.3205Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0908 29.8L37.3086 32.1804L38.5022 32.5639L38.0908 29.8Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0908 29.8L38.8651 32.1749L37.6634 32.5639L38.0908 29.8Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4822 31.5274L37.9649 31.5298L37.9637 32.7774L40.4822 31.5274Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4822 31.5262L38.4435 32.9969L37.7045 31.9868L40.4822 31.5262Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1636 37.024L32.679 37.0179L32.6758 38.2617L30.1636 37.024Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1606 37.021L32.1953 38.4873L32.9383 37.4729L30.1606 37.021Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0754 39.8162L31.8584 37.4353L33.0513 37.8183L31.0754 39.8162Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.072 39.8129L33.1129 38.3398L32.376 37.3322L31.072 39.8129Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0339 39.8129L31.9985 38.3457L32.7407 37.3322L34.0339 39.8129Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0361 39.8109L33.2608 37.4353L32.0602 37.8236L34.0361 39.8109Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5598 35.2904L31.7776 37.6708L32.9712 38.0543L32.5598 35.2904Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5598 35.2904L33.3341 37.6652L32.1324 38.0543L32.5598 35.2904Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9512 37.0178L32.4339 37.0202L32.4327 38.2678L34.9512 37.0178Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9512 37.0166L32.9125 38.4873L32.1735 37.4772L34.9512 37.0166Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_4192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuAiActLogo);
export default __webpack_public_path__ + "static/media/eu-ai-act-logo.35140bee343a8397990d06e3e5c48fae.svg";
export { ForwardRef as ReactComponent };